/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsImage: {
  name: 'image';
  data: string;
} = {
  name: 'image',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 2A1.5 1.5 0 0 1 2 .5h12A1.5 1.5 0 0 1 15.5 2v12a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 14V2Zm14 0v8.793l-3.544-3.544a1.5 1.5 0 0 0-1.94-.156L1.5 12.523V2a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5Zm-13 12v-.244l8.102-5.852a.5.5 0 0 1 .647.052l4.251 4.251V14a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5ZM5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
